import React, { FunctionComponent } from 'react';
import styles from './MainSettingsMenu.module.scss';
import { SettingIcon } from 'app/assets/images/icons';
import { Link } from 'react-router-dom';
import { Popper, ClickAwayListener, Fade, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  settings_paper: {
    border: '1px solid var(--borderColor)',
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
  },
}));

interface Props {
  items: any[];
  icon?: any;
}

const MainSettingsMenu: FunctionComponent<Props> = ({ items, icon }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<any>();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef?.current?.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <div className={styles.MainSettingsMenu}>
      <button
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        data-testid="dots-icon-holder"
      >
        {icon ? icon : <SettingIcon style={{ width: 17, height: 17 }} />}
      </button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        data-testid="popper-holder"
      >
        {({ TransitionProps }) => (
          <ClickAwayListener
            onClickAway={handleClose}
            data-testid="listener-holder"
          >
            <Fade {...TransitionProps} timeout={350}>
              <div className={`${classes.settings_paper} ${styles.popperMenu}`}>
                {items.map((item) => (
                  <Link
                    to={item?.link}
                    onClick={() => {
                      handleToggle();
                    }}
                    key={item?.text}
                  >
                    {item?.text}
                  </Link>
                ))}
              </div>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
};

export default MainSettingsMenu;
